


























































































































































































































































import {
  CalculatorTable,
  Checkbox,
  Container,
  TextField,
} from "@/components";
import apiClient from "@/services/api.client";
import { ContingentOffset } from "@/types";
import { formatCurrency, formatDate } from "@/utils";
import LayoutDefault from "../layouts/LayoutDefault.vue";
import Vue from "vue";
import { Federation } from "@/models/Federation";
import { mapGetters } from "vuex";
import { ContingentOffsetDataUtils } from "@/types/contingent-offset";

const dateSort = (a: any, b: any): any => {
  const dateA = new Date(a).getTime();
  const dateB = new Date(b).getTime();
  return dateA - dateB;
};

export default Vue.extend({
  name: "ContingentOffset",
  components: {
    Container,
    Checkbox,
    TextField,
    LayoutDefault,
    CalculatorTable,
  },
  data() {
    return {
      tableHeaders: [
        {
          text: "Nummer",
          value: "nhoNumber",
        },
        {
          text: "Organisasjoner",
          value: "associations",
        },
        {
          text: "Kontingent med AX",
          value: "axTotal",
        },
        {
          text: "Kontingent her",
          value: "contingentTotal",
        },
        {
          text: "Differanse",
          value: "difference",
        },
        {
          text: "%",
          value: "differenceAsPercentage",
        },
        {
          text: "Sist endret",
          value: "lastChanged",
          sort: dateSort,
        },
        { text: "Valg", value: "actions", sortable: false },
      ],
      items: [] as ContingentOffset[],
      isOffsetDialogOpen: false,
      isDistributionDialogOpen: false,
      distributionText: "",
      clickedOffset: {
        nhoNumber: 0,
        associations: [],
        associationsText: "",
        contingentTotal: 0,
        axTotal: 0,
        difference: 0,
        differenceAsPercentage: 0,
        crmInvoice: {
          total: 0,
          invoiceNumber: 0,
          nhoNumber: 0,
        },
        contingentResponse: {},
      } as ContingentOffset,
      offset: 50,
      year: new Date().getFullYear(),
      loading: false,
      filter: {
        nhoNumber: "",
        associations: "",
        contingentResponse: "",
      },
      usePercentage: false,
    };
  },
  computed: {
    ...mapGetters(["associations"]),
    filteredOffsets(): Array<ContingentOffset> {
      const filteredOffsets = ContingentOffsetDataUtils.filterOffsets(
        this.items,
        this.filter
      );

      return filteredOffsets;
    },
  },
  watch: {
    isOffsetDialogOpen(val) {
      val || this.close();
    },
    isDistributionDialogOpen(val) {
      val || this.close();
    },
  },
  created() {
    this.fetchUpdatedData(false);
  },
  methods: {
    close(): void {
      this.isOffsetDialogOpen = false;
      this.isDistributionDialogOpen = false;
    },
    getInvoiceUrl(invoiceNumber: number): string {
      return `https://invoiceapi.nho.no/api/pdf?id=${invoiceNumber}`;
    },
    getOffsetLabel(): string {
      return this.usePercentage
        ? "Tillatt differanse i prosent"
        : "Tillatt differanse";
    },
    getSearchPlaceholder(): string {
      return "Prøv å søk med ord1&ord2!ord3...";
    },
    getRecalculateLabel(): string {
      const itemsToRecalculate = this.filteredOffsets.length;
      if (itemsToRecalculate == 0) return "Beregn";
      return `Beregn ${this.filteredOffsets.length} ~ ${Math.round(
        itemsToRecalculate / 100 + 7
      )} sek`;
    },
    openInfoDialog(offset: ContingentOffset): void {
      this.isOffsetDialogOpen = true;
      this.clickedOffset = offset;
      console.log(offset);
    },
    openDistributionDialog(): void {
      this.loading = true;
      apiClient
        .getOffsetDistributionPerMo(this.year, this.offset, {
          recalculate: false,
          mock: false,
          usePercentage: this.usePercentage,
        })
        .then((text: string) => {
          this.isDistributionDialogOpen = true;
          this.distributionText = text;
          this.loading = false;
        })
        .catch((err: unknown) => {
          console.log("Error: ", err);
          this.$toast.error("Klarte ikke å hente fordeling");
          this.loading = false;
        });
    },
    fetchUpdatedData(recalculate: boolean): void {
      this.loading = true;
      apiClient
        .getContingentOffsets(this.year, this.offset, {
          recalculate,
          mock: false,
          usePercentage: this.usePercentage,
        })
        .then((offsets) => {
          this.items = offsets.map((item) => {
            item.associationsText = this.getAssociationsText(
              item.associations
            );
            return item;
          });
          this.$toast.success("Hentet avvik");
          this.loading = false;
        })
        .catch((err: unknown) => {
          console.log("Error: ", err);
          this.$toast.error("Klarte ikke å hente avvik");
          this.loading = false;
        });
    },
    recalculateMultiple(): void {
      this.loading = true;
      apiClient
        .recalculateContingentOffsets(
          this.year,
          this.filteredOffsets.map((offset) => offset.nhoNumber)
        )
        .then((updatedOffsets) => {
          this.insertUpdatedOffsets(updatedOffsets);
          this.$toast.success(`Oppdaterte ${updatedOffsets.length} avvik`);
          this.loading = false;
        })
        .catch((err: any) => {
          console.log("Error: ", err);
          const error =
            err.response?.data ?? `Klarte ikke å oppdatere avviksdata}`;
          this.$toast.error(error);
          this.loading = false;
        });
    },
    recalculateOne(offset: ContingentOffset): void {
      this.loading = true;
      apiClient
        .recalculateContingentOffset(this.year, offset.nhoNumber)
        .then((updatedOffset) => {
          this.insertUpdatedOffsets([updatedOffset]);
          this.$toast.success(`Oppdaterte avvik`);
          this.loading = false;
        })
        .catch((err: any) => {
          console.log("Error: ", err.response.data);
          const error =
            err.response?.data ??
            `Klarte ikke å oppdatere avviksdata for ${offset.nhoNumber}`;
          this.$toast.error(error);
          this.loading = false;
        });
    },
    insertUpdatedOffsets(updatedOffsets: ContingentOffset[]): void {
      const nhoNumbers = updatedOffsets.map((offset) => offset.nhoNumber);

      this.items = this.items.map((item) => {
        if (nhoNumbers.includes(item.nhoNumber)) {
          const updatedOffset = updatedOffsets.find(
            (offset) => offset.nhoNumber == item.nhoNumber
          );
          if (updatedOffset) {
            updatedOffset.associationsText = this.getAssociationsText(
              item.associations
            );
            return updatedOffset;
          }
        }
        return item;
      });
    },
    getPrettyObjectString(object: any): string {
      return JSON.stringify(object, undefined, 2);
    },
    getDistributionDialogHeader(): string {
      if (this.usePercentage) return "Andel avvik per organisasjon";
      return "Antall avvik per organisasjon";
    },
    getNameFromNumber(nhoNumber: number): string {
      const item: Federation = this.associations.find(
        (org: Federation) => org.nhoNumber === nhoNumber
      );
      return item?.name ?? "?";
    },
    getAssociationsText(nhoNumbers: number[]): string {
      return [...new Set(nhoNumbers)]
        .map(
          (nhoNumber) => `${nhoNumber} (${this.getNameFromNumber(nhoNumber)})`
        )
        .join(", ");
    },
    getDifferenceAsPercentage(offset: ContingentOffset): string {
      return `${Math.round(offset.differenceAsPercentage)}`;
    },
    convertToCurrency(num: number, hideCurrencyLabel = false): string {
      return formatCurrency(num, hideCurrencyLabel);
    },
    formatDate(lastChanged: string): string {
      return formatDate(lastChanged);
    },
  },
});
